import "core-js/modules/es.array.index-of";
import "regenerator-runtime/runtime";

/*
 * Copyright (c) 2018 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
*/

/* eslint-disable wf-security/no-location-href */
import { put, take, select, delay } from 'redux-saga/effects';
import { push, replace } from 'connected-react-router';
import { waitUntil } from 'wfui-digital-core/es/lib';
import { getLocation } from '../../selectors';
import { NAVIGATION_PUSH_LOGOFF_PROMPT, setLogoffPromptPushed } from '../actions'; // The delays after dispatching the replace action (waitUntil and delay) fix
// an issue where the back button doesn't behave as expected when an entry is pushed
// onto the browser stack immediately after replacing it.
//
// 1. Replace the browser path with 'promptLogoff'
// 2. Push another entry on the history stack (the original path)
//
// Browser stack after saga execution:
//
//   - /previousUrl
//   - /current-path/promptLogoff
//   - /current-path
//
// Without the delay, a browser back event skips over the "promptLogoff" entry and navigates
// the user back to "previousUrl".

export var watchPushLogoffPrompt = /*#__PURE__*/regeneratorRuntime.mark(function watchPushLogoffPrompt() {
  var _yield$take, defaultPath, _yield$select, pathname, path;

  return regeneratorRuntime.wrap(function watchPushLogoffPrompt$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!true) {
            _context.next = 24;
            break;
          }

          _context.next = 3;
          return take(NAVIGATION_PUSH_LOGOFF_PROMPT);

        case 3:
          _yield$take = _context.sent;
          defaultPath = _yield$take.path;
          _context.next = 7;
          return select(getLocation);

        case 7:
          _yield$select = _context.sent;
          pathname = _yield$select.pathname;
          path = defaultPath || pathname;
          _context.next = 12;
          return delay(300);

        case 12:
          _context.next = 14;
          return put(replace("".concat(path, "/promptLogoff")));

        case 14:
          _context.next = 16;
          return waitUntil(function () {
            return window.location.hash.indexOf('promptLogoff') !== -1;
          });

        case 16:
          _context.next = 18;
          return delay(300);

        case 18:
          _context.next = 20;
          return put(push(path));

        case 20:
          _context.next = 22;
          return put(setLogoffPromptPushed(true));

        case 22:
          _context.next = 0;
          break;

        case 24:
        case "end":
          return _context.stop();
      }
    }
  }, watchPushLogoffPrompt);
});